var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1715.6 999.93 1228.5 323.17 533.92 320.28 1021.02 997.05 528.31 1669.73 1222.91 1672.6 1715.6 999.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFat);
export default __webpack_public_path__ + "static/media/arrow-fat.f2f8e4d8f75da3e82cd1f4d3267c5d10.svg";
export { ForwardRef as ReactComponent };